import { Fragment } from "react";
import CodeTracking from "../../Utils/CodeTracking";

const OrderRow = (props) => {
  let singleOrder = props.customerOrderList.filter(
    (o) => o.orderID_GUID === props.orderGUID
  )[0];

  //***********************Redirect to Customer Single Order Page with Measurements */
  const redirectToSingleOrderWithMeasurement = function (
    customerGUID,
    orderID
  ) {
    // alert(customerGUID + ", " + orderID);
    const win = window.open(
      "/Customer/" + customerGUID + "/Order/" + orderID,
      "_blank"
    );
    win.focus();
    // history.push("/Measurement/${customerGUID}");
  };

  return (
    // customerOrderList
    // customerOrderList.filter((o) => o.orderID_GUID === orderGUID)
    <Fragment>
      {CodeTracking.showTrackingPosition("Order -> per row  2424792739823h2")}

      <tr>
        <th>{props.indexno}</th>
        <td>{singleOrder.orderDate}</td>
        <td>{singleOrder.orderID}</td>
        <td>{singleOrder.deliveryDate}</td>
        <td>
          <button
            onClick={() =>
              redirectToSingleOrderWithMeasurement(
                props.customerGUID,
                props.orderGUID
              )
            }
          >
            <span className="badge badge-danger px-2">Measurement Detail</span>
          </button>
        </td>
      </tr>
    </Fragment>
  );
};

export default OrderRow;
